<mat-card appearance="outlined" class="logout-card">
  <mat-card-header class="no-text-margin">
    <h3>{{ 'youWillNowBeLoggedOut' | translate }}</h3>
  </mat-card-header>
  <mat-card-content>
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </mat-card-content>
</mat-card>
